import Pride2026Details from './pride-2026-details.vue'

export default {
    pride2026: Pride2026Details,
}
